import cn from "classnames";
import { t } from "i18next";
import { ForwardedRef, forwardRef } from "react";

import { RadioButtonProps } from "./RadioButton.types";

import styles from "./RadioButton.module.scss";

const RadioButton = forwardRef(
  (
    { label, className, ...props }: RadioButtonProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <label className={cn(styles["radio-button"], className)}>
        <input
          ref={ref}
          type="radio"
          className={styles["radio-button__input"]}
          {...props}
        />
        {label ? t(label) : null}
      </label>
    );
  }
);

RadioButton.displayName = "RadioButton";

export default RadioButton;
